import React from 'react';
import MainContent from './components/MainContent';
import SignInSide from './components/SignIn';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import SignUp from './components/SignUp';
// import Home from './components/Home';
import Contact from './components/Contact';
import { About } from './components/About';
import AppointmentBooking from './components/AppointmentBooking';
import QueryLogs from './components/QueryLogs';
import Forgotpassword from './components/Forgotpassword';
import { ConfirmProvider } from 'material-ui-confirm';
import { AppContextProvider } from './state/AppContext';
import { CONST_ROUTE_PATH } from './route/RouteConstants';
import ProtectedRoute from './route/ProtectedRoute';
// import { OnboardRequest } from './components/OnboardRequest';
import { PageNotFound } from './components/PageNotFound';
// import { Payment } from './components/Payment';
// import { Pricing } from './components/Pricing';
import { ResponseHandler } from './components/ResponseHandler';
import { PaymentStatus } from './components/PaymentStatus';
import VerifyEmail from './components/VerifyEmail';
import { TermsAndConditions } from './components/TermsAndConditions';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { RefundPolicy } from './components/RefundPolicy';
import { ChatPDF } from './components/ChatPDF';
import DashboardCapture from './components/DashboardCapture';
import { CloudEstimator } from './components/CloudEstimator';
import { DataCentreCalculator } from './components/DataCentreCalculator';
import AzureDashboardCapture from './components/AzureDashboardCapture';

function App() {
  return (
    <AppContextProvider>
      <ConfirmProvider>
          <BrowserRouter>
            <Routes>
              <Route path='/' exact Component={SignInSide} />
              <Route path={CONST_ROUTE_PATH.ABOUT} exact Component={About} />
              <Route path={CONST_ROUTE_PATH.PRODUCTS} exact Component={About} />
              <Route path={CONST_ROUTE_PATH.SERVICES} exact Component={About} />
              <Route path={CONST_ROUTE_PATH.BLOGS} exact Component={About} />
              <Route path={CONST_ROUTE_PATH.SCHEDULE_MEETING} exact Component={AppointmentBooking} />
              <Route path={CONST_ROUTE_PATH.QUERY_LOGS} exact Component={QueryLogs} />
              <Route path={CONST_ROUTE_PATH.CONTACT_US} exact Component={Contact} />
              <Route path={CONST_ROUTE_PATH.TERMS_CONDITIONS} exact Component={TermsAndConditions} />
              <Route path={CONST_ROUTE_PATH.PRIVACY_POLICY} exact Component={PrivacyPolicy} />
              <Route path={CONST_ROUTE_PATH.REFUND_POLICY} exact Component={RefundPolicy} />
              <Route path={CONST_ROUTE_PATH.SIGN_IN} exact Component={SignInSide} />
              <Route path={CONST_ROUTE_PATH.SIGN_UP} exact Component={SignUp} />
              <Route path={CONST_ROUTE_PATH.FORGOT_PASSWORD} exact Component={Forgotpassword} />
              <Route path={CONST_ROUTE_PATH.RESET_PASSWORD} exact Component={Forgotpassword} />
              <Route path={CONST_ROUTE_PATH.PAGE_NOT_FOUND} exact Component={PageNotFound} />
              <Route path={CONST_ROUTE_PATH.VERIFY_EMAIL} exact Component={VerifyEmail} />
              {/* <Route path={CONST_ROUTE_PATH.ONBOARD_REQUEST} exact Component={OnboardRequest} /> */}
              <Route path={CONST_ROUTE_PATH.CLOUD_ESTIMATOR} exact Component={CloudEstimator} />
              {/* <Route path={`${CONST_ROUTE_PATH.PAYMENT}/:details`} Component={Payment} /> */}
              <Route path={`${CONST_ROUTE_PATH.RESPONSE_HANDLER}`} Component={ResponseHandler} />
              <Route path={`${CONST_ROUTE_PATH.THANK_YOU}`} Component={PaymentStatus} />
              <Route path={`${CONST_ROUTE_PATH.PAYMENT_FAILED}/:code`} Component={PaymentStatus} />
              <Route path={`${CONST_ROUTE_PATH.CHAT_PDF}`} Component={ChatPDF} />
              <Route path={`${CONST_ROUTE_PATH.DASHBOARD_CAPTURE}`} Component={DashboardCapture} />
              <Route path={`/azure${CONST_ROUTE_PATH.DASHBOARD_CAPTURE}`} Component={AzureDashboardCapture} />
              <Route path={`${CONST_ROUTE_PATH.DATA_CENTRE_COST_CALCULATOR}`} Component={DataCentreCalculator} />

              {/* Protected Routes */}
              <Route exact path={CONST_ROUTE_PATH.PRICING} element={<ProtectedRoute />}>
                <Route exact path={CONST_ROUTE_PATH.PRICING} element={<MainContent />} />
              </Route>

              <Route exact path={CONST_ROUTE_PATH.ADD_ACCOUNT} element={<ProtectedRoute />}>
                <Route exact path={CONST_ROUTE_PATH.ADD_ACCOUNT} element={<MainContent />} />
              </Route>

              <Route exact path={CONST_ROUTE_PATH.DASHBOARD} element={<ProtectedRoute />}>
                <Route exact path={CONST_ROUTE_PATH.DASHBOARD} element={<MainContent />} />
              </Route>

              <Route exact path={CONST_ROUTE_PATH.MY_PROFILE} element={<ProtectedRoute />}>
                <Route exact path={CONST_ROUTE_PATH.MY_PROFILE} element={<MainContent />} />
              </Route>

              <Route exact path={`${CONST_ROUTE_PATH.OPTIMIZATION.BASE}/`} element={<ProtectedRoute />}>
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.EC2} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.EBS} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.RDS} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.S3} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.ELASTIC_IP} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.ASG} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.EBS_SNAPSHOT} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.RDS_SNAPSHOT} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.MANAGED_DISKS} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.BIQ_QUERY} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.COMPUTE_ENGINE} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.CLOUD_SQL} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.CLOUD_RUN} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.ECS} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.LAMBDA} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.ROI} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.VIRTUAL_MACHINE} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.MANAGED_DISKS_SNAPSHOT} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.BLOB_STORAGE} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.VM_SCALE_SET} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.CONTAINER_INSTANCE} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.PUBLIC_IP} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.AZURE_ROI} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.AZURE_WEB_APP} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.AZURE_STATIC_WEB_APP} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.AZURE_DB_MYSQL} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.AZURE_DB_POSTGRESSQL} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.OPTIMIZATION.AZURE_DB_SQL} element={<MainContent />} />
              </Route>

              <Route exact path={`${CONST_ROUTE_PATH.INVENTORY.BASE}/`} element={<ProtectedRoute />}>
                <Route exact path={CONST_ROUTE_PATH.INVENTORY.REPORTS} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.INVENTORY.EC2} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.INVENTORY.ECS} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.INVENTORY.ASG} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.INVENTORY.EBS} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.INVENTORY.LAMBDA} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.INVENTORY.RDS} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.INVENTORY.S3} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.INVENTORY.SAVING_COST} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.INVENTORY.GLOBAL_SCAN} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.INVENTORY.CLOUD_ESTIMATOR} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.INVENTORY.VIRTUAL_MACHINE} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.INVENTORY.VIRTUAL_MACHINE_SS} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.INVENTORY.AZURE_REPORTS} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.INVENTORY.AZURE_DB_MYSQL} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.INVENTORY.AZURE_DB_POSTGRESSQL} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.INVENTORY.AZURE_DB_SQL} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.INVENTORY.TAG_START_STOP} element={<MainContent />} />
              </Route>

              <Route exact path={`${CONST_ROUTE_PATH.BILLING.BASE}/`} element={<ProtectedRoute />}>
                <Route exact path={CONST_ROUTE_PATH.BILLING.CLOUD_COST_CONSOLE} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.BILLING.COST_EXPLORER} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.BILLING.DATA_TRANSFER} element={<MainContent />} />
              </Route>

              <Route exact path={`${CONST_ROUTE_PATH.DEVOPS.BASE}/`} element={<ProtectedRoute />}>
                <Route path={`${CONST_ROUTE_PATH.DEVOPS.SETUP_INFRASTRUCTURE}`} element={<MainContent />} />
                <Route path={`${CONST_ROUTE_PATH.DEVOPS.MANAGE_SERVICE}`} element={<MainContent />} />
                <Route path={`${CONST_ROUTE_PATH.DEVOPS.EXECUTE_CUSTOM_COMMANDS}`} element={<MainContent />} />
                <Route path={`${CONST_ROUTE_PATH.DEVOPS.MONITORING}`} element={<MainContent />} />
              </Route>

              <Route exact path={`${CONST_ROUTE_PATH.SECURITY.BASE}/`} element={<ProtectedRoute />}>
                <Route path={`${CONST_ROUTE_PATH.SECURITY.ACCOUNT_SCAN_RESULT}`} element={<MainContent />} />
                <Route path={`${CONST_ROUTE_PATH.SECURITY.ACCOUNT_SCAN}`} element={<MainContent />} />
              </Route>

              <Route exact path={`${CONST_ROUTE_PATH.SETTINGS.BASE}/`} element={<ProtectedRoute />}>
                <Route path={`${CONST_ROUTE_PATH.SETTINGS.USER_MANAGEMENT}`} element={<MainContent />} />
                <Route path={`${CONST_ROUTE_PATH.SETTINGS.USER_TAG_MANAGEMENT}`} element={<MainContent />} />
                <Route path={`${CONST_ROUTE_PATH.SETTINGS.INVOICE}`} element={<MainContent />} />
                <Route path={`${CONST_ROUTE_PATH.SETTINGS.NOTIFICATIONS}`} element={<MainContent />} />
              </Route>

              <Route exact path={CONST_ROUTE_PATH.K8S.BASE} element={<ProtectedRoute />}>
                <Route exact path={CONST_ROUTE_PATH.K8S.CONNECT_K8S_CLUSTER} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.K8S.GIT_REPO_CONNECTION} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.K8S.DEPLOY_TOOLS} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.K8S.DEPLOY_APP_ON_EKS} element={<MainContent />} />
                <Route exact path={CONST_ROUTE_PATH.K8S.MONITOR_K8S_CLUSTER} element={<MainContent />} />
              </Route>


              <Route path="*" Component={PageNotFound} />
            </Routes>
          </BrowserRouter>
        </ConfirmProvider>
    </AppContextProvider>
  );
}

export default App;
